<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12 biamain">
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-md-12 maindvin-pgbulk">
              <div class="tptxt-blkactvtypg mb-3">
                <h5>Bulk Import</h5>
                <div class="d-flex flex-column gap-2 align-items-end">
                  <a><button type="button" class="btn-actvtytp" (click)="onCloseImport()">Close Import</button></a>
                  <a
                    ><button type="button" class="btn-actvtytp" (click)="downloadTemplate()">
                      DOWNLOAD TEMPLATE
                    </button></a
                  >
                </div>
              </div>
              <div class="actvtypg-stepadddv d-none">
                <div class="row steppg">
                  <div class="col-md-3 col-6 text-center active-stp">
                    <h3>1</h3>
                    <p>Import File</p>
                  </div>
                  <div class="col-md-3 col-6 text-center">
                    <h3>2</h3>
                    <p>Map Fields & Data</p>
                  </div>
                  <div class="col-md-3 col-6 text-center">
                    <h3>3</h3>
                    <p>Review Data</p>
                  </div>
                  <div class="col-md-3 col-6 text-center">
                    <h3>4</h3>
                    <p>Import</p>
                  </div>
                </div>
              </div>
              <div class="stpbx-blkpg">
                <div class="wizard my-5">
                  <ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
                    <li
                      class="nav-item flex-fill"
                      role="presentation"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Step 1"
                      (click)="nextClick(1)">
                      <a
                        class="nav-link active rounded-circle mx-auto d-flex align-items-center justify-content-center cursor-pointer"
                        id="step1-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="step1"
                        aria-selected="true">
                        1
                      </a>
                      <p>Import File</p>
                    </li>
                    <li
                      class="nav-item flex-fill"
                      role="presentation"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Step 2"
                      (click)="nextClick(2)">
                      <a
                        class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center cursor-pointer"
                        id="step2-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="step2"
                        aria-selected="false"
                        title="Step 2">
                        2
                      </a>
                      <p>Map Fields & Data</p>
                    </li>
                    <li
                      class="nav-item flex-fill"
                      role="presentation"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Step 3"
                      (click)="nextClick(3)">
                      <a
                        class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center cursor-pointer"
                        id="step3-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="step3"
                        aria-selected="false"
                        title="Step 3">
                        3
                      </a>
                      <p>Review Data</p>
                    </li>
                    <li
                      class="nav-item flex-fill"
                      role="presentation"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Step 4"
                      (click)="nextClick(4)">
                      <a
                        class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center cursor-pointer"
                        id="step4-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="step4"
                        aria-selected="false"
                        title="Step 4">
                        4
                      </a>
                      <p>Import</p>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div role="tabpanel" id="step1" *ngIf="currentStep === 1" aria-labelledby="step1-tab">
                      <p *ngIf="selectedFile == null">
                        Download the template shown above. Fill in all the data as per the template and upload that
                        excel file here.
                      </p>
                      <p *ngIf="!sheetNames && selectedFile">Select the sheet which you want to upload.</p>
                      <div class="biast1">
                        <div class="biast1t">
                          <div class="upload-filecustm text-center mt-4">
                            <div id="dropzone">
                              <div *ngIf="!selectedFile">
                                <p>Drag & Drop the file</p>
                                <p>or</p>
                                <button type="button" class="btn-selectfile">
                                  <input type="file" accept=".xls, .xlsx, .csv" (change)="onFileSelected($event)" />
                                  Select File
                                </button>
                              </div>
                              <div *ngIf="selectedFile">
                                <div class="file-show mb-2 attachment-container">
                                  <i class="fa fa-check-circle margin-vertical-middle"></i>
                                  <span>{{ selectedFile?.name }}</span>
                                  <i
                                    (click)="deleteSelectedFile()"
                                    class="fa fa-trash margin-vertical-middle delete-icon"
                                    style="float: right"
                                    aria-hidden="true">
                                  </i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="my-3 text-center">
                            <button
                              type="button"
                              [ngClass]="selectedFile != null  ? 'btnpg-upload' : 'btn-discard'"
                              (click)="upload()"
                              [disabled]="selectedFile == null">
                              Upload File
                            </button>
                          </div>
                        </div>

                        <div class="text-center col-md-4 offset-md-4 biast1b">
                          <select
                            class="form-select"
                            aria-label="Select Sheet"
                            (change)="onSheetNameChange($event.target.value)">
                            <option [selected]="true" [disabled]="true">Select Sheet</option>
                            <option *ngFor="let sheetName of sheetNames" [value]="sheetName">{{sheetName}}</option>
                          </select>
                          <button
                            class="mt-5"
                            [disabled]="selectedSheetName == null"
                            [ngClass]="selectedSheetName != null  ? 'btn-save' : 'btn-discard'"
                            (click)="doStartImporting()">
                            START IMPORTING
                          </button>
                          <div *ngIf="fileReadStatus$ | async as fileStatus">{{fileStatus?.message}}</div>
                        </div>

                        <div class="d-flex justify-content-end d-none">
                          <a class="btn btn-info next">Continue <i class="fas fa-angle-right"></i></a>
                        </div>
                      </div>
                    </div>

                    <div role="tabpanel" id="step2" *ngIf="currentStep === 2" aria-labelledby="step2-tab">
                      <div *ngIf="fileReadStatus$ | async as fileReadStatus">
                        <div *ngIf="fileReadStatus.error">
                          <p class="mat-h3">There is an error in reading the selected file</p>
                          <p class="mat-h3">{{fileReadStatus.message}}</p>
                          <p class="mat-h3">You can go back select another file and continue</p>
                        </div>
                        <ng-container *ngIf="!fileReadStatus.error">
                          <p>Map each of the column heads with the respective data to start the import.</p>
                          <div class="biast2">
                            <div class="column-container" *ngIf="columns$ | async as columns">
                              <div
                                class="col"
                                [ngStyle]="column?.customStyle ? column.customStyle : {}"
                                *ngFor="let column of columns; index as i">
                                <h4>{{column.column}}</h4>
                                <select class="form-select" (change)="OnChangeColMap($event.target.value, i)">
                                  <option selected [value]="-1">Select Column</option>
                                  <option
                                    *ngFor="let fileColumn of fileColumns; index as j"
                                    [value]="j"
                                    [selected]="fileColumn === column.column">
                                    {{fileColumn}}
                                  </option>
                                </select>
                                <cdk-virtual-scroll-viewport
                                  appendOnly
                                  itemSize="10"
                                  [items]="filteredDataRows"
                                  class="example-viewport">
                                  <div class="biast2b">
                                    <div *cdkVirtualFor="let data of filteredDataRows">{{data[column.column]}}</div>
                                  </div>
                                </cdk-virtual-scroll-viewport>
                              </div>
                            </div>

                            <div class="row bias2bot">
                              <div class="col-12 text-end mt-3">
                                <p>{{columns$?.getValue()?.length}} Columns in Total</p>
                              </div>
                              <div class="col-12 text-center mt-5">
                                <a><button class="btn-discard" (click)="prevClick(1)">Previous</button></a>
                                <a
                                  ><button
                                    class="btn-save"
                                    (click)="nextClick(3)"
                                    [ngClass]="!isColumnsUnmatched() ? 'btn-save' : 'btn-discard'"
                                    [disabled]="isColumnsUnmatched()">
                                    Next
                                  </button></a
                                >
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <div class="d-flex justify-content-between d-none">
                          <a class="btn btn-secondary previous"><i class="fas fa-angle-left"></i> Back</a>
                          <a class="btn btn-info next" [disabled]="fileReadStatus.error"
                            >Continue <i class="fas fa-angle-right"></i
                          ></a>
                        </div>
                      </div>
                    </div>

                    <div role="tabpanel" id="step3" *ngIf="currentStep === 3" aria-labelledby="step3-tab">
                      <p>You now have the option to edit, select, un-select and delete the import data</p>
                      <div class="biast3">
                        <div class="col-12">
                          <div class="table-responsive estable">
                            <table id="example" class="table table-striped table-bordered table-sm row-border hover">
                              <thead>
                                <tr>
                                  <th>
                                    <input type="checkbox" [(ngModel)]="isSelectAllChecked" (change)="selectAll()" />
                                  </th>
                                  <ng-container *ngFor="let col of headerCheck | columnFilter">
                                    <th>
                                      <div class="bulk-import-table-head">
                                        {{col.column}}

                                        <br />
                                        <div class="sort-icons" *ngIf="col.sortFn" (click)="applySort(col)">
                                          <span *ngIf="sortDirection[col.column] === 'ASC'">
                                            <i class="fa fa-caret-up" aria-hidden="true"></i>
                                          </span>
                                          <span *ngIf="sortDirection[col.column] === 'DESC'">
                                            <i class="fa fa-caret-down" aria-hidden="true"></i>
                                          </span>
                                          <span *ngIf="!sortDirection[col.column]">
                                            <i class="fa fa-sort" aria-hidden="true"></i>
                                          </span>
                                        </div>
                                      </div>
                                      <br />
                                      <input
                                        *ngIf="col?.isFilterable"
                                        type="text"
                                        class="search_text"
                                        [placeholder]="'Search ' + col.column"
                                        [(ngModel)]="headerFilters[col.column]"
                                        (input)="applyFilters()" />
                                      <input
                                        *ngIf="!col?.isFilterable"
                                        type="text"
                                        class="search_text"
                                        [placeholder]="'Search ' + col.column" />
                                    </th>
                                  </ng-container>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngIf="doneValidation$ | async">
                                  <tr
                                    *ngFor="let row of filteredDataRows | slice:(currentPage - 1) * itemsPerPage:(currentPage * itemsPerPage)"
                                    [ngClass]="{'error-row': row?.hasValidationError}">
                                    <td>
                                      <input
                                        type="checkbox"
                                        [(ngModel)]="row.isSelected"
                                        (change)="syncIsAllSelectCheckbox(); markSelectedInRowsToSave(row.index)" />
                                    </td>
                                    <ng-container *ngFor="let c of headerCheck | columnFilter; index as cI">
                                      <td
                                        *ngIf="(formGrid.get(((row.index + 1) * 1000 + cI)).errSummary | async) as ce"
                                        [ngClass]="{'table-danger': ce.flag, 'color-white': ce.flag}"
                                        [matTooltip]="ce.message">
                                        <p *ngIf="!ce.flag" class="mb-0">
                                          {{formGrid.get((row.index + 1) * 1000 + cI).fControl.value}}
                                        </p>
                                        {{ setRowValidationError(row) }}
                                        <ng-container *ngIf="ce.flag">
                                          <ng-container *ngIf="!c.inValues">
                                            <input
                                              type="text"
                                              [formControl]="formGrid.get(((row.index + 1) * 1000 + cI)).fControl"
                                              class="form-control is-invalid" />
                                            <div class="invalid-feedback">
                                              <div class="color-black">{{ce.message}}</div>
                                            </div>
                                          </ng-container>

                                          <ng-container *ngIf="c.inValues">
                                            <mat-select
                                              style="padding: 10px"
                                              [formControl]="formGrid.get(((row.index + 1) * 1000 + cI)).fControl">
                                              <mat-option *ngFor="let v of c.inValues" [value]="v.match"
                                                >{{v.display}}</mat-option
                                              >
                                            </mat-select>
                                            <div class="invalid-feedback">
                                              <div class="color-black">{{ce.message}}</div>
                                            </div>
                                          </ng-container>
                                        </ng-container>
                                      </td>
                                    </ng-container>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                          <div class="pagination">
                            <button *ngIf="currentPage > 1" (click)="onPageChange(currentPage - 1)">&lt;</button>
                            <button
                              *ngFor="let page of getPaginationRange()"
                              [ngClass]="{ 'active': currentPage === page }"
                              (click)="onPageChange(page)">
                              {{ page }}
                            </button>
                            <button
                              *ngIf="currentPage < filteredDataRows.length / itemsPerPage"
                              (click)="onPageChange(currentPage + 1)">
                              &gt;
                            </button>
                          </div>
                        </div>
                        <div class="col-12 text-end mt-5 bias3bot">
                          <a><button class="btn-discard" (click)="prevClick(2)">Previous</button></a>
                          <a><button class="btn-save" (click)="nextClick(4)">Next</button></a>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between d-none">
                        <a class="btn btn-secondary previous"><i class="fas fa-angle-left"></i> Back</a>
                        <a class="btn btn-info next">Continue <i class="fas fa-angle-right"></i></a>
                      </div>
                    </div>

                    <div
                      role="tabpanel"
                      id="step4"
                      *ngIf="currentStep === 4 && validator.document.showUpload"
                      aria-labelledby="step4-tab">
                      <p>Upload Document Zip.</p>
                      <div class="biast1">
                        <div class="biast1t">
                          <div class="upload-filecustm text-center mt-4">
                            <div id="dropzone">
                              <div>
                                <p>Drag & Drop the file</p>
                                <p>or</p>
                                <button type="button" class="btn-selectfile">
                                  <input
                                    type="file"
                                    accept=".zip,.rar,.7zip"
                                    (change)="onDocumentZipSelected($event)" />
                                  Select Document ZIP File
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="my-3 text-center">
                            <button
                              type="button"
                              [ngClass]="selectedDocumentFile != null  ? 'btnpg-upload' : 'btn-discard'"
                              (click)="uploadDocumentZipFile()"
                              [disabled]="selectedDocumentFile == null">
                              Upload Zip File
                            </button>
                          </div>
                          <div *ngIf="!validator.document.isRequired" class="my-3 text-center">
                            <button type="button" [ngClass]="'btn-discard'" (click)="nextClick(5)">Skip</button>
                          </div>
                        </div>

                        <div class="text-center col-md-4 offset-md-4 biast1b">
                          <select
                            class="form-select"
                            aria-label="Select Sheet"
                            (change)="onSheetNameChange($event.target.value)">
                            <option [selected]="true" [disabled]="true">Select Sheet</option>
                            <option *ngFor="let sheetName of sheetNames" [value]="sheetName">{{sheetName}}</option>
                          </select>
                          <button
                            class="mt-5"
                            [disabled]="selectedSheetName == null"
                            [ngClass]="selectedSheetName != null  ? 'btn-save' : 'btn-discard'"
                            (click)="doStartImporting()">
                            START IMPORTING
                          </button>
                        </div>

                        <div class="d-flex justify-content-end d-none">
                          <a class="btn btn-info next">Continue <i class="fas fa-angle-right"></i></a>
                        </div>
                      </div>
                    </div>
                    <div role="tabpanel" id="step5" *ngIf="currentStep === 5" aria-labelledby="step5-tab">
                      <p class="importing-text" *ngIf="!apiResponse">Importing...</p>
                      <ng-container *ngIf="apiResponse && apiResponse.status == 1">
                        <p>
                          Whoop! Your bulk upload is completed successfully. Download the imported data to view the
                          status.
                        </p>
                        <div class="biast4">
                          <div class="col-md-4 offset-md-4 text-center">
                            <div></div>
                            <h5 class="text-end">100%</h5>
                            <h4>{{apiResponse?.response?.successCount}} Records Updated successfully</h4>
                            <h4>{{apiResponse?.response?.errorCount}} Errors</h4>
                            <h4>{{apiResponse?.response?.duplicateCount || 0}} Duplicates</h4>
                            <button class="btn-save mt-3" (click)="viewImportedData(apiResponse?.response)">
                              VIEW IMPORTED DATA
                            </button>
                            <p (click)="deleteImportedData(apiResponse?.response)">Delete last imported data</p>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between d-none">
                          <a class="btn btn-secondary previous"><i class="fas fa-angle-left"></i> Back</a>
                          <a class="btn btn-info next">Submit <i class="fas fa-angle-right"></i></a>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="apiResponse && apiResponse.status == 0">
                        <p class="text-center">Import failed.</p>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
